module.exports = __webpack_public_path__ + "img/05_bg.7fd3d570.jpg";